import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import axios from "axios";
import { mirage } from "ldrs";
import gsap from "gsap";
import localforage from "localforage";
import { IoMdMore } from "react-icons/io";

const EditMemo = () => {
  mirage.register();
  const [saved, setsaved] = useState(false);
  const [categories, setCategories] = useState([]);
  const [pass, setPass] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCategories, setFilteredCategories] = useState(categories);
  const [state, setstate] = useState();
  const [type, setType] = useState();

  const input_pass = useRef(null);
  const messageText = useRef(null);
  const message = useRef(null);
  const messageSpanSvg = useRef(null);
  const loader = useRef(null);
  const actionsRef = useRef([]);

  useEffect(() => {
    showMemos();
  }, []);
  async function showMemos() {
    const pass = await localforage.getItem("passcode");
    if (pass) {
      try {
        showloader();

        const res = await axios.get(
          "https://joodyy.netlify.app/.netlify/functions/app/create/allcategory"
        );
        if (res.data.state == true) {
          setCategories(res.data.allCategories);
          hideloader();
        }
      } catch (error) {
        console.log(error);
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  function show() {
    var tl = gsap.timeline();
    tl.fromTo(
      input_pass.current,
      { y: 100, opacity: 0, pointerEvents: "none" },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.7,
        ease: "expo.out",
      }
    );
  }
  async function showMessage(text) {
    const tl = gsap.timeline({});
    message.current.style = "";
    await tl
      .fromTo(
        message.current,
        {
          top: "-2rem",
        },
        {
          top: "1rem",
          ease: "elastic.out(1,0.5)",
          duration: 1.5,
          overwrite: true,
        }
      )
      .fromTo(
        message.current,
        {
          minWidth: "0px",
        },
        {
          minWidth: "180px",
          ease: "elastic.out(1,0.75)",
          duration: 1,
        }
      )
      .fromTo(
        messageText.current,
        {
          opacity: 0,
          flexGrow: 0,
          textContent: "",
          height: "0",
        },
        {
          textContent: text,
          flexGrow: 1,
          height: "fit-content",
          opacity: 1,
        }
      )
      .fromTo(
        messageSpanSvg.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
        }
      )
      .to(messageText.current, {
        opacity: 0,
        delay: 2,
      })
      .to(messageText.current, {
        flexGrow: 0,
        height: "0",
      })
      .to(messageSpanSvg.current, {
        opacity: 0,
        delay: -1,
      })
      .to(messageText.current, {
        textContent: "",
      })
      .to(message.current, {
        minWidth: "0px",
      })
      .to(message.current, {
        top: "-3rem",
      });
  }
  function showloader() {
    gsap.to(loader.current, { opacity: 1 });
  }
  function hideloader() {
    gsap.to(loader.current, { opacity: 0 });
  }
  function hide() {
    gsap.to(input_pass.current, {
      y: 100,
      opacity: 0,
      pointerEvents: "none",
      duration: 0.7,
      ease: "expo.out",
    });
  }
  async function addpasscode() {
    showloader();
    try {
      const data = {
        pass: pass,
      };
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/create/pass",
        data
      );

      hideloader();
      if (response.data.state == true) {
        hide();
        await localforage.setItem("passcode", pass);
        showMemos();
      } else {
        setsaved(null);
        await showMessage(response.data.message);
      }
    } catch (error) {
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  const error = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  );
  const done = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill=""
    >
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );
  const edit = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z" />
    </svg>
  );
  const dlt = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
    </svg>
  );
  useEffect(() => {
    if (categories.length > 0) {
      memosAnimation();
    }
  }, [categories]);
  function memosAnimation() {
    const tl = gsap.timeline({});
    tl.fromTo(
      ".memo",
      { opacity: 0, scale: 1.3 },
      {
        opacity: 1,
        scale: 1,
        stagger: 0.1,
        ease: "elastic.out(1.2,0.75)",
        duration: 2,
      }
    );
  }
  async function searchAnimation() {
    var tl = gsap.timeline({});
    await tl.fromTo(
      ".memo",
      { opacity: 0, scale: 1, y: 20 },
      {
        opacity: 1,
        scale: 1,
        y: 0,
        stagger: 0.1,
        ease: "elastic.out(1.2,0.75)",
        duration: 2,
      }
    );
  }
  const handleSearchChange = (event) => {
    const newSearchTerm = event.target.value.toLowerCase();
    setSearchTerm((prev) => (prev = newSearchTerm));

    const filtered = categories.filter((category) =>
      category.category.toLowerCase().includes(newSearchTerm)
    );
    setFilteredCategories((prev) => (prev = filtered));
    if (filtered.length > 0) {
      setstate((prev) => (prev = event.target.value));
    } else {
      setstate(null);
    }
  };
  useEffect(() => {
    if (state && state !== null && state !== "") {
      searchAnimation();
    }
  }, [state]);
  useEffect(() => {
    if (searchTerm.length === 0 && categories.length > 0) {
      searchAnimation();
    }
  }, [searchTerm]);
  async function deleteCategory() {
    try {
      console.log(type);
      showloader();
      const data = {
        type: type,
      };
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/create/removeCategory",
        data
      );
      if (response.data.state === true) {
        setsaved("done");
        hideloader();
        fadeOut();
        showMemos();
        await showMessage(response.data.message);
      } else {
        setsaved(null);
        hideloader();
        fadeOut();
        await showMessage(response.data.message);
      }
    } catch (error) {
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  async function editCategory(e, newName) {
    try {
      if (e !== newName) {
        showloader();
        const data = {
          type: e,
          newName: newName,
        };
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/editCategory",
          // "http://localhost:5001/create/editCategory",
          data
        );
        if (response.data.state === true) {
          setsaved("done");
          showMemos();
          hideloader();
          await showMessage(response.data.message);
        } else {
          setsaved(null);
          hideloader();
          await showMessage(response.data.message);
        }
      }
    } catch (error) {}
  }
  const handleActionsClick = (index, e) => {
    if (!actionsRef.current[index]) return;
    const moreElement = e.target.parentNode.querySelector(".more");
    actionsRef.current[index].isExpanded =
      !actionsRef.current[index].isExpanded; // Update state within ref

    if (actionsRef.current[index].isExpanded) {
      gsap.fromTo(
        moreElement,
        { opacity: 0, top: "-90%" },
        {
          top: "-140%",
          opacity: 1,
          pointerEvents: "all",
          duration: 0.3,
        }
      );
    } else {
      gsap.fromTo(
        moreElement,
        { opacity: 1, top: "-140%" },
        {
          top: "-180%",
          opacity: 0,
          pointerEvents: "none",
          duration: 0.3,
        }
      );
    }
  };
  async function activeEdit(e, type) {
    var more = await e.target.parentNode;
    var memo = more.closest(".memo");
    var p = await memo.querySelector("#category");
    var value = p.getAttribute("contentEditable");
    var edit = await more.querySelector("#edit>p");
    if (value === "true") {
      edit.textContent = "edit";
      p.contentEditable = "false";
      p.dataset.active = "false";
      editCategory(type, p.textContent);
    } else {
      p.dataset.active = "true";
      edit.textContent = "save";
      p.contentEditable = "true";
    }
  }
  function fadeIn(type) {
    setType(type);
    gsap.fromTo(
      ".alert",
      { opacity: 0, y: 20 },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.3,
      }
    );
  }
  function fadeOut() {
    gsap.fromTo(
      ".alert",
      { opacity: 1, y: 0 },
      {
        y: -20,
        opacity: 0,
        pointerEvents: "none",
        duration: 0.3,
      }
    );
  }
  return (
    <article
      onDoubleClick={() => {
        var tl = gsap.timeline({});
        var more = document.querySelectorAll(".more");
        actionsRef.current.forEach((el) => {
          el.isExpanded = false;
        });
        tl.to(more, {
          top: "-170%",
          opacity: 0,
          pointerEvents: "none",
          duration: 0.3,
        });
      }}
    >
      <div className="message" ref={message}>
        <p ref={messageText}></p>
        <span ref={messageSpanSvg}>
          {saved === null && error}
          {saved === "done" && done}
        </span>
      </div>
      <div className="alert">
        <h3>Are you sure you want to delete this category!!</h3>
        <p>this will result of deleteing all memos</p>
        <div className="btns">
          <button onClick={fadeOut}>
            <p>no</p>
          </button>
          <button onClick={deleteCategory}>
            <p>yes</p>
          </button>
        </div>
      </div>
      <form
        className="input_pass"
        ref={input_pass}
        onSubmit={(e) => {
          e.preventDefault();
          addpasscode();
        }}
      >
        <label htmlFor="pass">
          <p>enter passcode</p>
          <input
            type="text"
            id="pass"
            name="pass"
            onChange={(e) => {
              setPass(e.target.value);
            }}
          />
        </label>
        <span>
          <p>enter passcode to continue</p>
        </span>
      </form>
      <div className="hero">
        <h1 id="color">memos</h1>
      </div>
      <section>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          id="search"
        >
          <input
            type="search"
            placeholder="search"
            id="input_search"
            value={searchTerm}
            onChange={(e) => {
              handleSearchChange(e);
            }}
          />
        </form>
        <div className="memos">
          {searchTerm.length === 0
            ? // Render all categories if search term is empty
              categories.map((category, index) => (
                <div className="memo" key={index}>
                  <p id="category" contentEditable={false}>
                    {category.category}
                  </p>
                  <div
                    ref={(el) => {
                      actionsRef.current[index] = el;
                      if (el) el.isExpanded = false; // Initialize expanded state
                    }}
                    className="actions"
                    onClick={(e) => {
                      handleActionsClick(index, e);
                    }}
                  >
                    <span>
                      <IoMdMore />
                    </span>
                  </div>
                  <div className="more">
                    <span
                      id="edit"
                      onClick={(e) => activeEdit(e, category.category)}
                    >
                      <p>edit</p>
                      {edit}
                    </span>
                    <div className="line"></div>
                    <span
                      id="dlt"
                      // onClick={() => deleteCategory(category.category)}
                      onClick={() => {
                        fadeIn(category.category);
                      }}
                    >
                      <p>delete</p>
                      {dlt}
                    </span>
                  </div>
                </div>
              ))
            : // Render filtered categories if search term has a value
              filteredCategories.map((category, index) => (
                <div className="memo" key={index}>
                  <p id="category" contentEditable={false}>
                    {category.category}
                  </p>
                  <div
                    ref={(el) => {
                      actionsRef.current[index] = el;
                      if (el) el.isExpanded = false; // Initialize expanded state
                    }}
                    className="actions"
                    onClick={(e) => {
                      handleActionsClick(index, e);
                    }}
                  >
                    <span>
                      <IoMdMore />
                    </span>
                  </div>
                  <div className="more">
                    <span
                      id="edit"
                      onClick={activeEdit}
                      data-type={category.category}
                    >
                      <p>edit</p>
                      {edit}
                    </span>
                    <div className="line"></div>
                    <span
                      id="dlt"
                      onClick={deleteCategory}
                      data-type={category.category}
                    >
                      <p>delete</p>
                      {dlt}
                    </span>
                  </div>
                </div>
              ))
              }

          <div className="box"></div>
        </div>
      </section>
      <div className="loader" ref={loader}>
        <l-mirage size="60" speed="2.5" color="black"></l-mirage>
      </div>
    </article>
  );
};

export default EditMemo;
